import type { FC } from 'react';

import { httpGetFaceRecognitionPersons } from '@iconik-io/iconik-api/src/services/ml';

import { useAppDispatch } from '../../../../store/react_redux_typed';
import { prepareQueryParameter } from '../../../../utils/search_utils/search_utils';
import type { SelectOption } from '../../../select_field/types';
import type { LoadOptionsResult } from '../../../select_field/utils';
import SelectFieldWrapper, {
  type SelectFieldWrapperProps,
} from '../select/select';
import Option from './option';

type Props = SelectFieldWrapperProps & {
  currentPersonId?: string;
  newPersonName?: string;
  newPersonImageUrl?: string;
};

export const SelectPersonFieldWrapper: FC<Props> = (props) => {
  const dispatch = useAppDispatch();

  const processNewOptionValue = (option: SelectOption) => ({
    ...option,
    label: option.label.trim(),
    personVersionFaceImageUrl: props.newPersonImageUrl,
  });

  const handleLoadOptions = async (
    query: string,
  ): Promise<LoadOptionsResult> => {
    const queryValue = prepareQueryParameter(query, { escapeMinus: true });
    return dispatch(
      httpGetFaceRecognitionPersons({
        per_page: 20,
        status_in: 'USER_CONFIRMED,SYSTEM_CONFIRMED',
        sort: 'name,asc',
        has_name: true,
        ...(queryValue && { name: queryValue }),
      }),
    ).then((response) => {
      const persons = response.body.objects.map((item) => ({
        label: item.name ?? '',
        value: item.id,
        imageUrl: item.image_url,
      }));

      if (props.currentPersonId) {
        return persons.filter((item) => item.value !== props.currentPersonId);
      }

      return persons;
    });
  };

  return (
    <SelectFieldWrapper
      {...props}
      preloadOptions
      loadOptions={handleLoadOptions}
      creatorText="Type + Enter to add new person"
      creatorAction="Add"
      optionComponent={Option}
      processNewOptionValue={processNewOptionValue}
      allowDuplicateSelectOptions
    />
  );
};

export default SelectPersonFieldWrapper;
